import Vue from 'vue';
import VueGtm from 'vue-gtm';
import VueDOMPurifyHTML from 'vue-dompurify-html';

// Polyfills
import registerPolyfills from './utils/polyfills';

import Sentry from './sentry';
import { SENTRY_DSN, IS_PRODUCTION } from './config';

import Auth from './auth';

import store from '@/store/index';
import router from './routes/index';
import i18n from './locales/index';
import './api';
import App from './App';
import registerGlobalComponents from './globalComponents';
import modal from './plugins/modal';
import removeUnusedStorageData from './services/removeUnusedStorageData';

Vue.config.productionTip = false

Vue.config.ignoredElements = ['react-widget']


Vue.use(VueGtm, {
  id: 'GTM-5MXW45L', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  enabled: IS_PRODUCTION, // IS_PRODUCTION, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: !IS_PRODUCTION, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
});

registerPolyfills();

// Intl polyfill for older browsers
if (!global.Intl) {
  require.ensure(
    ['intl', 'intl/locale-data/jsonp/en.js', 'intl/locale-data/jsonp/fa.js'],
    require => {
      require('intl');
      require('intl/locale-data/jsonp/fa.js');
      require('intl/locale-data/jsonp/en.js');
    },
  );
}

Vue.use(Sentry, {
  dsn: SENTRY_DSN,
  enable: IS_PRODUCTION,
});

Vue.use(Auth, { router });
Vue.use(VueDOMPurifyHTML, {
  default: {
    ALLOWED_ATTR: ['target', 'href', 'class', 'id', 'dir'],
  },
});
// the global modal
Vue.use(modal, store);

// global register frequently used components
registerGlobalComponents(Vue);

// Garbage collect unused keys inside storage
removeUnusedStorageData();

// Create and mount the root instance.
// Make sure to inject the router with the router option to make the
// whole app router-aware.
new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
}).$mount('#app');
